import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const DefaultIcon = (props: SvgIconProps) => {
    const { white } = colors;

    return (
        <SvgIcon {...props}>
            <rect
                x="2.5"
                y="2.5"
                width="19"
                height="19"
                rx="9.5"
                fill={white}
                stroke="currentColor"
            />
        </SvgIcon>
    );
};

export default DefaultIcon;
